import { render, staticRenderFns } from "./SideMenuLink.vue?vue&type=template&id=4cbd2bcd&scoped=true"
import script from "./SideMenuLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuLink.vue?vue&type=style&index=0&id=4cbd2bcd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd2bcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cbd2bcd')) {
      api.createRecord('4cbd2bcd', component.options)
    } else {
      api.reload('4cbd2bcd', component.options)
    }
    module.hot.accept("./SideMenuLink.vue?vue&type=template&id=4cbd2bcd&scoped=true", function () {
      api.rerender('4cbd2bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SideMenuLink.vue"
export default component.exports